var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.667C16.1868 13.667 19.9999 16.0915 20 19.0723V22H3V19.0723C3.00008 16.0915 6.81315 13.667 11.5 13.667ZM11.5 2C14.3126 2 16.6005 4.24262 16.6006 7C16.6006 9.75745 14.3126 12 11.5 12C8.68753 11.9998 6.40039 9.75732 6.40039 7C6.40047 4.24275 8.68758 2.00021 11.5 2Z",
    fill: "url(#paint0_linear_39_28387)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_28387",
    x1: 11.5,
    y1: 2,
    x2: 11.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b3b46d422eac1c65b67bc7e64dc1be05.svg";
export { ForwardRef as ReactComponent };